module.exports = __webpack_public_path__ + "img/teams-grid-zoom-plus.a6a44c0d.svg";